import { SheinRedirectionPage } from '@app/pages/redirection/platforms/shein';
import { RedirectionPageProps } from '@app/pages/redirection/types';
// eslint-disable-next-line no-restricted-imports
import { EcommercePlatform } from '@client/data/platform';
import React from 'react';

export function RedirectionPage({ platformName }: RedirectionPageProps) {
  if (platformName === EcommercePlatform.Shein) {
    return <SheinRedirectionPage />;
  }
  return null;
}
